import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'abc-sliding-header',
	templateUrl: './abc-sliding-header.component.html',
	styleUrls: ['./abc-sliding-header.component.css']
})
export class AbcSlidingHeaderComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}
